app.controller("TimetableEditRoomController", [
    "$scope", "TimetableService", "$uibModalInstance", "$state", "StaticData", "toastr", "params",
    function ($scope, TimetableService, $uibModalInstance, $state, StaticData, toastr, params) {
        var room = params.room;

        $scope.roomId = params.room._id;
        $scope.buildingId = room.building;
        $scope.name = room.name;
        $scope.area = room.area;
        $scope.count = room.seatCount;
        $scope.floor = room.floor;
        $scope.withComputers = room.withComputers;
        $scope.withSmartBoard = room.withSmartBoard;
        $scope.additional = room.additional;

        $scope.fetchBuildings = function () {
            StaticData.getItemsByKey("buildings").then(function (buildings) {
                $scope.buildings = buildings;
            });
        };

        $scope.fetchBuildings();

        $scope.edit = function () {
            TimetableService.editRoom({
                roomId: $scope.roomId,
                name: $scope.name,
                area: $scope.area,
                seatCount: $scope.count,
                floor: $scope.floor,
                building: $scope.buildingId,
                withComputers: $scope.withComputers,
                withSmartBoard: $scope.withSmartBoard,
                additional: $scope.additional
            }).then(function () {
                toastr.success('', 'ოთახი რედაქტირებულია');
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
